import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Coordinate from '../geom/Coordinate';
import Double from '../../../../java/lang/Double';
import DD from '../math/DD';
var CGAlgorithmsDD = /*#__PURE__*/function () {
  function CGAlgorithmsDD() {
    _classCallCheck(this, CGAlgorithmsDD);
  }
  _createClass(CGAlgorithmsDD, null, [{
    key: "orientationIndex",
    value: function orientationIndex(p1, p2, q) {
      var index = CGAlgorithmsDD.orientationIndexFilter(p1, p2, q);
      if (index <= 1) return index;
      var dx1 = DD.valueOf(p2.x).selfAdd(-p1.x);
      var dy1 = DD.valueOf(p2.y).selfAdd(-p1.y);
      var dx2 = DD.valueOf(q.x).selfAdd(-p2.x);
      var dy2 = DD.valueOf(q.y).selfAdd(-p2.y);
      return dx1.selfMultiply(dy2).selfSubtract(dy1.selfMultiply(dx2)).signum();
    }
  }, {
    key: "signOfDet2x2",
    value: function signOfDet2x2() {
      if (arguments[3] instanceof DD && arguments[2] instanceof DD && arguments[0] instanceof DD && arguments[1] instanceof DD) {
        var x1 = arguments[0],
          y1 = arguments[1],
          x2 = arguments[2],
          y2 = arguments[3];
        var det = x1.multiply(y2).selfSubtract(y1.multiply(x2));
        return det.signum();
      } else if (typeof arguments[3] === 'number' && typeof arguments[2] === 'number' && typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
        var dx1 = arguments[0],
          dy1 = arguments[1],
          dx2 = arguments[2],
          dy2 = arguments[3];
        var _x = DD.valueOf(dx1);
        var _y = DD.valueOf(dy1);
        var _x2 = DD.valueOf(dx2);
        var _y2 = DD.valueOf(dy2);
        var _det = _x.multiply(_y2).selfSubtract(_y.multiply(_x2));
        return _det.signum();
      }
    }
  }, {
    key: "intersection",
    value: function intersection(p1, p2, q1, q2) {
      var px = new DD(p1.y).selfSubtract(p2.y);
      var py = new DD(p2.x).selfSubtract(p1.x);
      var pw = new DD(p1.x).selfMultiply(p2.y).selfSubtract(new DD(p2.x).selfMultiply(p1.y));
      var qx = new DD(q1.y).selfSubtract(q2.y);
      var qy = new DD(q2.x).selfSubtract(q1.x);
      var qw = new DD(q1.x).selfMultiply(q2.y).selfSubtract(new DD(q2.x).selfMultiply(q1.y));
      var x = py.multiply(qw).selfSubtract(qy.multiply(pw));
      var y = qx.multiply(pw).selfSubtract(px.multiply(qw));
      var w = px.multiply(qy).selfSubtract(qx.multiply(py));
      var xInt = x.selfDivide(w).doubleValue();
      var yInt = y.selfDivide(w).doubleValue();
      if (Double.isNaN(xInt) || Double.isInfinite(xInt) || Double.isNaN(yInt) || Double.isInfinite(yInt)) return null;
      return new Coordinate(xInt, yInt);
    }
  }, {
    key: "orientationIndexFilter",
    value: function orientationIndexFilter(pa, pb, pc) {
      var detsum = null;
      var detleft = (pa.x - pc.x) * (pb.y - pc.y);
      var detright = (pa.y - pc.y) * (pb.x - pc.x);
      var det = detleft - detright;
      if (detleft > 0.0) {
        if (detright <= 0.0) return CGAlgorithmsDD.signum(det);else detsum = detleft + detright;
      } else if (detleft < 0.0) {
        if (detright >= 0.0) return CGAlgorithmsDD.signum(det);else detsum = -detleft - detright;
      } else return CGAlgorithmsDD.signum(det);
      var errbound = CGAlgorithmsDD.DP_SAFE_EPSILON * detsum;
      if (det >= errbound || -det >= errbound) return CGAlgorithmsDD.signum(det);
      return 2;
    }
  }, {
    key: "signum",
    value: function signum(x) {
      if (x > 0) return 1;
      if (x < 0) return -1;
      return 0;
    }
  }]);
  return CGAlgorithmsDD;
}();
export { CGAlgorithmsDD as default };
CGAlgorithmsDD.DP_SAFE_EPSILON = 1e-15;